import { createResource } from "~/lib/resourceFactory";
import { listAssociations } from "./association.api";
import type { EntityType } from "./association.schema";

type AssociationsParams = {
  businessId: string;
  entityType: EntityType;
  entityId: string;
  targetType?: EntityType;
};

type AssociationsList = Awaited<ReturnType<typeof listAssociations>>;

export const AssociationsResource = createResource<
  AssociationsList,
  AssociationsParams
>({
  key: (p) =>
    [
      "association",
      p.businessId,
      p.entityType,
      p.entityId,
      p.targetType ?? "",
    ] as const,
  fetcher: (p) =>
    listAssociations({
      data: {
        businessId: p.businessId,
        entityType: p.entityType,
        entityId: p.entityId,
        targetType: p.targetType,
      },
    }),
});
